import BusLink from "./core/BusLink";
export const webWorkerBus = (workerSelf) => (request) => {
    // eslint-disable-next-line no-param-reassign
    workerSelf.onmessage = (event) => request(event.data, (response) => workerSelf.postMessage(response));
};
export const createWebWorkerBusLink = (worker) => new BusLink({
    requestHandler: (request) => worker.postMessage(request),
    registerResponseHandler: (handler) => {
        // eslint-disable-next-line no-param-reassign
        worker.onmessage = (event) => handler(event.data);
    },
});
//# sourceMappingURL=webworker.js.map